// src/store/slices/permissionSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchMyPermissionsThunk = createAsyncThunk(
  "permissions/fetchMy",
  async (_, { rejectWithValue }) => {
    try {
      // ✅ FIX: correct URL (mounted at /api/admin)
      const res = await api.get("/api/my-permissions");
      return res.data?.permissions ?? [];
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message ||
          err.response?.data?.success === false
          ? err.response?.data?.message
          : err.message || "Failed to load permissions"
      );
    }
  }
);

function normKey(k) {
  return String(k || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/-/g, "_");
}

function toMap(list) {
  const map = {};
  (list || []).forEach((p) => {
    const key = normKey(p.module_key);
    map[key] = {
      can_view: Number(p.can_view) === 1,
      can_create: Number(p.can_create) === 1,
      can_update: Number(p.can_update) === 1,
      can_delete: Number(p.can_delete) === 1,
    };
  });
  return map;
}

const permissionSlice = createSlice({
  name: "permissions",
  initialState: {
    list: [],
    map: {},
    loading: false,
    loaded: false,
    error: null,
  },
  reducers: {
    clearPermissions(state) {
      state.list = [];
      state.map = {};
      state.loading = false;
      state.loaded = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyPermissionsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyPermissionsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.loaded = true;
        state.list = action.payload || [];
        state.map = toMap(state.list);
      })
      .addCase(fetchMyPermissionsThunk.rejected, (state, action) => {
        state.loading = false;
        state.loaded = true;
        state.error = action.payload || "Failed to load permissions";
        state.list = [];
        state.map = {};
      });
  },
});

export const { clearPermissions } = permissionSlice.actions;
export default permissionSlice.reducer;
